// extracted by mini-css-extract-plugin
export default {"FeatureSection":"FeatureSection-module__FeatureSection__tk8yE"};